import {
  getCurrentYearNum,
  getDayName,
  getWeekDateByWeekNumber,
} from "lib/date";
import { postcodes } from "lib/global";
import { serverGet, serverPost } from "lib/serverRequest";
import { addressDetailInfo } from "models/third/addressRight";
import moment from "moment";

export const getBoxes = ({ user_id = "", onFinish = () => {} }) => {
  serverGet({ url: `box/${user_id}`, onFinish: onFinish });
};

export const getBoxesWithYear = ({
  year = getCurrentYearNum(),
  onFinish = () => {},
}) => {
  serverGet({ url: `box/all/${year}`, onFinish: onFinish });
};

export const createBox = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: `box/create`,
    data: {
      user_id: data?.user_id ?? 0,
      address: data?.address ?? {},
      frequency: data?.frequency?.name ?? "",
      status: data?.status ?? "",
      cutoff_date: data?.cutoff_date,
      pies: data?.pies ?? [],
    },
    onFinish: onFinish,
  });
};

export const updateBox = ({ data = {}, onFinish = () => {} }) => {
  serverPost({
    url: `box/update`,
    data: {
      id: data?.id ?? 0,
      user_id: data?.user_id ?? 0,
      address: data?.address ?? {},
      frequency: data?.frequency?.name ?? "",
      status: data?.status?.value ?? "",
      cutoff_date: data?.cutoff_date,
      pies: data?.pies ?? [],
      week_next_num: data?.week_next_num?.value || null,
      weekly_slot_id: data?.weekly_slot_id ?? "",
      log_data: data?.log_data ?? {},
      same_week: data?.same_week,
      week_day: data?.week_day,
    },
    onFinish: onFinish,
  });
};

export const getBoxDate = async (item = {}) => {
  let { week_year, week_num, week_next_num, week_day } = item;
  week_num = Boolean(week_next_num) ? week_next_num : week_num;
  let dispatchDate = getWeekDateByWeekNumber(week_num, week_day - 1, week_year);
  let deliveryDate = getWeekDateByWeekNumber(
    week_num,
    week_day - (week_day === 5 ? 1 : 0),
    week_year
  );
  let bakedDate = getWeekDateByWeekNumber(week_num, week_day - 2, week_year);
  // if (week_day === 5) {
  //   const addressDetails = await addressDetailInfo(address?.id);
  //   if (
  //     postcodes.some(
  //       (postcode) => postcode === addressDetails?.structured_address?.postcode
  //     )
  //   ) {
  //     deliveryDate = getWeekDateByWeekNumber(week_num, week_day - 1, week_year);
  //   } else {
  //     dispatchDate = getWeekDateByWeekNumber(week_num + 1, 0, week_year);
  //     deliveryDate = getWeekDateByWeekNumber(week_num + 1, 1, week_year);
  //     bakedDate = getWeekDateByWeekNumber(week_num, 4, week_year);
  //   }
  // }
  if (week_day === 1) {
    bakedDate = getWeekDateByWeekNumber(week_num - 1, 4, week_year);
  }
  return {
    baked_date: bakedDate,
    delivery_date: deliveryDate,
    dispatch_date: dispatchDate,
  };
};

export const getNewBoxDates = async (date, type, boxInfo) => {
  const day = date.getDay();
  let week_day = boxInfo?.week_day;
  let week_num = Boolean(boxInfo?.week_next_num)
    ? boxInfo?.week_next_num
    : boxInfo?.week_num;
  const week = moment(date).isoWeek();
  const year = moment(date).isoWeekYear();
  if (type === "baked") {
    week_day = day + 1;
    week_num = week;
    if (day === 5) {
      week_day = 1;
      week_num = week + 1;
    }
  }
  if (type === "dispatch") {
    week_day = day;
    week_num = week;
  }
  if (type === "delivery") {
    if (day === 5) {
      const addressDetails = await addressDetailInfo(boxInfo?.address?.id);
      if (
        postcodes.some(
          (postcode) =>
            postcode === addressDetails?.structured_address?.postcode
        )
      ) {
        week_day = day;
        week_num = week;
      } else {
        week_day = day - 1;
        week_num = week;
      }
    } else {
      week_num = week;
      week_day = day - 1;
    }
  }
  return {
    week_day: week_day,
    week_num: week_num,
    week_next_num: week_num,
    week_year: year,
  };
};

export const checkSubLog = ({
  changerName = "",
  newValue = {},
  initData = {},
}) => {
  let log = "";
  //check the change pies
  const newPies = newValue?.pies ?? [];
  const initPies = initData?.pies ?? [];
  let changePies = newPies?.reduce(
    (ret, cur, index) =>
      cur?.id !== initPies?.[index]?.id
        ? [...ret, { ...cur, pieIndex: index }]
        : ret,
    []
  );
  //check boxdetail form.
  const checkFields = ["address", "frequency", "week_next_num", "status"];
  const newSubData = {
    address: newValue?.address?.id ?? "",
    frequency: newValue?.frequency?.name ?? newValue?.frequency ?? "",
    week_next_num: newValue?.week_next_num?.value ?? 2,
    status: newValue?.status?.value ?? 1,
  };
  const initSubData = {
    ...initData,
    week_next_num: initData?.week_next_num?.value ?? 2,
    address: initData?.address?.id ?? "",
  };
  const diffKeys = checkFields?.reduce(
    (ret, key) =>
      Boolean((newSubData?.[key] ?? "") !== initSubData?.[key])
        ? [...ret, key]
        : ret,
    []
  );
  if (diffKeys?.length > 0 || changePies?.length > 0) {
    let changeKeys = "";
    let changeValues = "";
    diffKeys.forEach((key, index) => {
      changeKeys += index === diffKeys?.length - 1 ? key : `${key}, `;
      changeValues +=
        index === diffKeys?.length - 1
          ? `${
              key === "frequency" ? initData?.[key] : initData?.[key]?.label
            } to ${newValue?.[key]?.label}`
          : `${
              key === "frequency" ? initData?.[key] : initData?.[key]?.label
            } to ${newValue?.[key]?.label}, `;
    });
    if (changePies?.length > 0) {
      changeKeys += Boolean(changeKeys) ? ", flavours" : "flavours ";
      let initPiesName = changePies?.reduce(
        (ret, cur) => ret + `${initPies?.[cur?.pieIndex]?.name},`,
        ""
      );
      let newPiesName = changePies?.reduce(
        (ret, cur) => ret + `${cur?.name},`,
        ""
      );
      changeValues += `${
        Boolean(changeValues) ? ", " : ""
      }Removed ${initPiesName} Added ${newPiesName}`;
    }
    log =
      `${changerName} ( admin ) - Subscription #${newValue?.id} - Update ${changeKeys} - ${changeValues}`.replace(
        /week_next_num/g,
        "next week slot"
      );
  }
  if (
    newValue?.same_week !== initData?.same_week ||
    newValue?.week_day !== initData?.week_day
  ) {
    log = `${changerName} ( admin ) - Subscription #${newValue?.id} - ${
      newValue?.same_week ? "Enable" : "Disable"
    } the Dispatch Day with ${getDayName(newValue?.week_day)} every week`;
  }
  return log;
};
